
export function setSitesScheduleSelected(state, data) {
  state.sitesScheduleSelected = data
}



